import React from "react";
import { Badge, HStack } from "@chakra-ui/react";
import {
  type FundCategoryKey,
  FUND_CATEGORY_CONFIGS,
  filterFundsByCategory,
} from "../../config/fundCategories";

type FundCategoryFilterProps<T extends { fundRegisterCode?: string }> = {
  funds: T[];
  selectedCategory: FundCategoryKey | "all";
  onChange: (category: FundCategoryKey | "all") => void;
  justify?: string;
  showAllOption?: boolean;
};

export const FundCategoryFilter = <T extends { fundRegisterCode?: string }>({
  funds,
  selectedCategory,
  onChange,
  justify = "flex-start",
  showAllOption = true,
}: FundCategoryFilterProps<T>) => (
  <HStack spacing={3} flexWrap="wrap" justify={justify}>
    {showAllOption ? (
      <Badge
        as="button"
        px={4}
        py={2}
        borderRadius="full"
        variant={selectedCategory === "all" ? "solid" : "subtle"}
        colorScheme="gray"
        onClick={() => onChange("all")}
      >
        همه صندوق‌ها
      </Badge>
    ) : null}
    {FUND_CATEGORY_CONFIGS.map((category) => {
      const count = filterFundsByCategory(funds, category.key).length;

      if (!count) {
        return null;
      }

      return (
        <Badge
          key={category.key}
          as="button"
          px={4}
          py={2}
          borderRadius="full"
          variant={selectedCategory === category.key ? "solid" : "subtle"}
          colorScheme={category.colorScheme}
          onClick={() => onChange(category.key)}
        >
          {category.title} ({count.toLocaleString("fa-IR")})
        </Badge>
      );
    })}
  </HStack>
);
